export default "__VITE_ASSET__bbc82d7a__"